export enum segmentType {
    plinth = 'plinth',
    middle = 'middle',
    crown = 'crown',
}